export default __webpack_public_path__ + "static/media/4851.9abc8d84.png";